// extracted by mini-css-extract-plugin
export default {"loading-mochi":"loading-mochi_loading-mochi__DfepZ","show":"loading-mochi_show__KFgLX"};